import { render } from "./ComplaintForm.vue?vue&type=template&id=45d2ea7f&scoped=true"
import script from "./ComplaintForm.vue?vue&type=script&lang=js"
export * from "./ComplaintForm.vue?vue&type=script&lang=js"

import "./ComplaintForm.vue?vue&type=style&index=0&id=45d2ea7f&lang=scss&scoped=true"

import exportComponent from "/workspace/source/scm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d2ea7f"]])

export default __exports__